import { useRepositoryQuery } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { useCancellationPolicyNameGetter } from '../../../../../components';

interface UseCentralCancellationPolicyOptionParams {
    bookablePeriod?: 'Month' | 'Night' | 'Day' | 'Hour';
}

export const useCentralCancellationPolicyOptions = ({ bookablePeriod }: UseCentralCancellationPolicyOptionParams) => {
    const getCancellationPolicyName = useCancellationPolicyNameGetter();
    const { data: cancellationPoliciesOptions, isFetching: isFetchingCancellationPolicies } = useRepositoryQuery(
        'portfolioCentralCancellationPolicies',
        'getAll',
        {},
        {
            select: (data) =>
                data?.centralCancellationPolicies
                    ?.filter((cancellationPolicy) =>
                        bookablePeriod
                            ? !cancellationPolicy.bookablePeriod || cancellationPolicy.bookablePeriod === bookablePeriod
                            : true
                    )
                    .map((cancellationPolicy) => {
                        const constructedName = getCancellationPolicyName(
                            {
                                ...cancellationPolicy,
                                applicabilityType: cancellationPolicy.applicability,
                            },
                            { format: 'parameters' }
                        );

                        return createOption({
                            label: cancellationPolicy.name || constructedName,
                            secondaryText: cancellationPolicy.name ? constructedName : null,
                            value: cancellationPolicy.id,
                        });
                    }),
        }
    );
    return { data: cancellationPoliciesOptions ?? [], isFetching: isFetchingCancellationPolicies };
};
